export default {"src":"/_next/static/media/retail_wereldhave.e2084459.svg","height":89,"width":446,"blurWidth":0,"blurHeight":0};